import { defineStore } from "pinia";
import http from "@/http";
import {
  LAUDO_TEMP,
  COMPONENTE_LAUDO_TEMP,
  NORMA_LAUDO_TEMP,
  CONDICAO_LAUDO_TEMP,
  RISCO_LAUDO_TEMP,
  MECANICO_LAUDO_TEMP,
  ELETRICO_LAUDO_TEMP,
  MOTOR_LAUDO_TEMP,
  RECOMENDACAO_LAUDO_TEMP,
} from "@/http/url";

export const useLaudoTecnicoStore = defineStore("LaudoTecnicoStore", {
  state: () => {
    return {
      laudos: [],
      componentes: [],
      normas: [],
      condicoes: [],
      riscos: [],
      mecanicos: [],
      eletricos: [],
      motores: [],
      recomendacoes: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  actions: {
    LISTAR_LAUDOSTECNICOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LAUDO_TEMP)
          .then((response) => {
            this.laudos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_COMPONENTES(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${COMPONENTE_LAUDO_TEMP + id}`)
          .then((response) => {
            this.componentes = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_NORMAS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${NORMA_LAUDO_TEMP + id}`)
          .then((response) => {
            this.normas = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_CONDICOES(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${CONDICAO_LAUDO_TEMP + id}`)
          .then((response) => {
            this.condicoes = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_RISCOS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${RISCO_LAUDO_TEMP + id}`)
          .then((response) => {
            this.riscos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_MECANICOS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${MECANICO_LAUDO_TEMP + id}`)
          .then((response) => {
            this.mecanicos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ELETRICOS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ELETRICO_LAUDO_TEMP + id}`)
          .then((response) => {
            this.eletricos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_MOTORES(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${MOTOR_LAUDO_TEMP + id}`)
          .then((response) => {
            this.motores = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_RECOMENDACOES(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${RECOMENDACAO_LAUDO_TEMP + id}`)
          .then((response) => {
            this.recomendacoes = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
  },

  getters: {
    getLaudos() {
      return this.laudos;
    },

    getFilterLaudos: (state) => {
      return (filtro) => {
        let filtrada = state.laudos;
        filtrada = filtrada.filter((obj) => !filtro || obj.modelo.includes(filtro));
        return filtrada;
      };
    },

    getComponentes(state) {
      return state.componentes;
    },

    getNormas(state) {
      return state.normas;
    },

    getCondicoes(state) {
      return state.condicoes;
    },

    getRiscos(state) {
      return state.riscos;
    },

    getMecanicos(state) {
      return state.mecanicos;
    },

    getEletricos(state) {
      return state.eletricos;
    },

    getMotores(state) {
      return state.motores;
    },

    getRecomendacoes(state) {
      return state.recomendacoes;
    },

    getLaudoLoad(state) {
      return state.loaded;
    },
  },
});
